// Auth Service - Handles Google OAuth and Email/Password Auth

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const authService = {
  // Initiate Google login
  loginWithGoogle: (redirectPath = '/community') => {
    const redirectUrl = window.location.origin + redirectPath;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  },

  // Legacy alias for Google login
  login: (redirectPath = '/community') => {
    authService.loginWithGoogle(redirectPath);
  },

  // Register with email/password
  register: async (email, password, name) => {
    const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email, password, name }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.detail || 'Registration failed');
    }

    // Store user locally
    authService.storeUser(data.user);
    return data;
  },

  // Login with email/password
  loginWithEmail: async (email, password) => {
    const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.detail || 'Login failed');
    }

    // Store user locally
    authService.storeUser(data.user);
    return data;
  },

  // Exchange session_id for session_token (Google OAuth callback)
  exchangeSession: async (sessionId) => {
    const response = await fetch(`${API_BASE_URL}/api/auth/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ session_id: sessionId }),
    });

    if (!response.ok) {
      throw new Error('Failed to exchange session');
    }

    return response.json();
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    return response.json();
  },

  // Logout
  logout: async () => {
    await fetch(`${API_BASE_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
    
    // Clear local storage
    localStorage.removeItem('gwins_user');
    localStorage.removeItem('gwins_player');
  },

  // Store user in localStorage for quick access
  storeUser: (user) => {
    localStorage.setItem('gwins_user', JSON.stringify(user));
  },

  // Get stored user
  getStoredUser: () => {
    const stored = localStorage.getItem('gwins_user');
    return stored ? JSON.parse(stored) : null;
  },
};

export default authService;
